/* ============================================================
   OCD "You might also need" (FBT): live category-fetch bundle
   Fetches from mapped collections (set in window.OCD_FBT.handles),
   rotates a pick from each, shows the add-ons, and supports
   individual add and add-all-to-cart.

   Single-collection categories (e.g. shoes to socks) instead show
   up to three options from the one collection, with individual Add
   buttons and no bundle summary.
   ============================================================ */
(function () {
  'use strict';

  var CFG = window.OCD_FBT || {};
  var SECTION = document.querySelector('[data-ocd-fbt]');
  if (!SECTION || !CFG.handles || !CFG.handles.length) return;
  var MOUNT = SECTION.querySelector('.ocd-fbt__mount');
  var TOP_POOL = 12;

  function money(n) { n = parseFloat(n); if (isNaN(n)) return ''; return (CFG.moneySymbol || '$') + n.toFixed(2); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function normalise(p) {
    var v = (p.variants && p.variants[0]) || {};
    var img = (p.images && p.images[0] && p.images[0].src) || '';
    return {
      id: String(p.id), handle: p.handle, brand: p.vendor || '', name: p.title || '',
      price: parseFloat(v.price != null ? v.price : 0), available: !!v.available, variantId: v.id, image: img,
      multi: !!(p.variants && p.variants.length > 1)
    };
  }

  function loadCollection(handle) {
    return fetch('/collections/' + handle + '/products.json?limit=250', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (d) { return ((d && d.products) || []).map(normalise); })
      .catch(function () { return []; });
  }

  function pickFrom(list, usedIds) {
    var pool = list.filter(function (p) {
      return p.available && p.variantId &&
        String(p.id) !== String(CFG.current.id) &&
        usedIds.indexOf(String(p.id)) === -1;
    }).slice(0, TOP_POOL);
    if (!pool.length) return null;
    return pool[Math.floor(Math.random() * pool.length)];
  }

  Promise.all(CFG.handles.map(loadCollection)).then(function (results) {
    var used = [], picks = [];
    var single = CFG.handles.length === 1;

    if (single) {
      // One mapped collection (shoes to socks): pick up to three options from it.
      var list = results[0] || [];
      for (var n = 0; n < 4; n++) {
        var s = pickFrom(list, used);
        if (s) { picks.push(s); used.push(String(s.id)); }
      }
    } else {
      // Multiple collections: one pick from each.
      results.forEach(function (list) {
        var p = pickFrom(list, used);
        if (p) { picks.push(p); used.push(String(p.id)); }
      });
    }

    if (!picks.length) { SECTION.style.display = 'none'; return; }
    render(picks, !single);
  });

  function itemCard(item, isCurrent) {
    var image = isCurrent ? CFG.current.image : item.image;
    var img = image ? '<img src="' + image + '" alt="' + esc(isCurrent ? CFG.current.title : item.name) + '" loading="lazy">' : '';
    var link = isCurrent ? CFG.current.url : ('/products/' + item.handle);
    var brand = isCurrent ? CFG.current.vendor : item.brand;
    var name = isCurrent ? CFG.current.title : item.name;
    var price = isCurrent ? CFG.current.price : item.price;
    var action = isCurrent
      ? '<span class="ocd-fbt__thisitem">This item</span>'
      : (item.multi
          ? '<a class="ocd-fbt__add" href="' + link + '">Choose options</a>'
          : '<button type="button" class="ocd-fbt__add" data-variant="' + item.variantId + '">Add to cart</button>');
    return '<div class="ocd-fbt__item' + (isCurrent ? ' is-current' : '') + '">'
      + '<a class="ocd-fbt__thumb" href="' + link + '">' + img + '</a>'
      + '<div class="ocd-fbt__brand">' + esc(brand) + '</div>'
      + '<div class="ocd-fbt__name"><a href="' + link + '">' + esc(name) + '</a></div>'
      + '<div class="ocd-fbt__price">' + money(price) + '</div>'
      + action
      + '</div>';
  }

  function render(picks, bundle) {
    var itemsHtml = '';
    picks.forEach(function (p, i) {
      if (bundle && i > 0) itemsHtml += '<span class="ocd-fbt__plus" aria-hidden="true">+</span>';
      itemsHtml += itemCard(p, false);
    });

    if (bundle) {
      var addonsTotal = picks.reduce(function (s, p) { return s + p.price; }, 0);
      MOUNT.innerHTML =
        '<div class="ocd-fbt__layout">'
        + '<div class="ocd-fbt__items">' + itemsHtml + '</div>'
        + '</div>';
    } else {
      // Options layout: no summary, cards sit as a centred group.
      MOUNT.innerHTML =
        '<div class="ocd-fbt__layout ocd-fbt__layout--options">'
        + '<div class="ocd-fbt__items">' + itemsHtml + '</div>'
        + '</div>';
    }

    MOUNT._picks = picks;
  }

  function addItems(items, btn) {
    var msg = MOUNT.querySelector('.ocd-fbt__msg');
    if (btn) { btn.disabled = true; btn._t = btn.textContent; btn.textContent = 'Adding\u2026'; }
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
    })
      .then(function (r) { if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || ('HTTP ' + r.status)); }); return r.json(); })
      .then(function (res) {
        if (btn) { btn.disabled = false; btn.textContent = btn._t; }
        refreshCart(res);
        if (msg) { msg.innerHTML = 'Added. <a href="/cart">View cart</a>'; msg.className = 'ocd-fbt__msg is-ok'; }
      })
      .catch(function (err) {
        if (btn) { btn.disabled = false; btn.textContent = btn._t; }
        if (msg) { msg.textContent = 'Could not add: ' + err.message; msg.className = 'ocd-fbt__msg is-err'; }
      });
  }

  function refreshCart(res) {
    try {
      if (res && res.sections) {
        var bubble = res.sections['cart-icon-bubble'];
        if (bubble) { var b = document.querySelector('#cart-icon-bubble'); if (b) { var tmp = document.createElement('div'); tmp.innerHTML = bubble; var s = tmp.querySelector('.shopify-section') || tmp; b.innerHTML = s.innerHTML; } }
        var drawerHtml = res.sections['cart-drawer'];
        if (drawerHtml) { var t2 = document.createElement('div'); t2.innerHTML = drawerHtml; var ni = t2.querySelector('.drawer__inner'); var li = document.querySelector('cart-drawer .drawer__inner'); if (ni && li) { li.innerHTML = ni.innerHTML; } var d = document.querySelector('cart-drawer'); if (d) { d.classList.remove('is-empty'); } }
      }
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') { drawer.open(); }
    } catch (e) { }
  }

  document.addEventListener('click', function (e) {
    var add = e.target.closest('.ocd-fbt__add');
    if (add && add.tagName !== 'A') { e.preventDefault(); addItems([{ id: add.getAttribute('data-variant'), quantity: 1 }], add); return; }
  });
})();